import { useEffect, useState } from "react";
import { RequestServer } from "../services";
import { APIRoutes } from "../../constants";

type Domains = {
  id: string;
  name: string;
  parent_id: string | null;
  level: string;
  created_at: Date | null;
  updated_at: Date | null;
}[];

export type FormattedDomains = {
  value: string;
  label: string;
  parent_id: string | null;
  level: string;
};

export interface combineLevelLabelDomainsData {
  value: number | string;
  label: string;
  level: string;
}

export const useDomainFetch = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [apiData, setApiData] = useState<{ [key: string]: FormattedDomains[] }>(
    {}
  );
  const [serverError, setServerError] = useState<any>(null);

  function getOptionFromLevel(level: string, id?: string){
      if (apiData?.keys?.length !> 0) return []
      if (level === "L0") return apiData["L0"]
      if (!id && id === "") return []
      if (!apiData[level]) return []

    return apiData[level].filter(item => item.parent_id === id)
  }

  // Combine level and label for dropdown option
  function getCombineLevelLabelDomains(): combineLevelLabelDomainsData[] {
    const outputArray: combineLevelLabelDomainsData[] = [];
    for (const level in apiData) {
      if (apiData.hasOwnProperty(level)) {
        const levelData = apiData[level as keyof FormattedDomains]
        if (Array.isArray(levelData)) {
          levelData.forEach((item) => {
            outputArray.push({
              value: item.value,
              label: `${level} - ${item.label}`, // Combine level and label
              level: item.level || level, // Use item.level if available, otherwise fallback to the key (L0, L1, etc.)
            });
          });
        }
      }
    }

    return outputArray.sort((a, b) => a.label.localeCompare(b.label));
  }

  useEffect(() => {
    setIsLoading(true);
    const fetchData = async () => {
      try {
        let domainsData = await RequestServer(APIRoutes.domains, "GET");
        let formattedDomains = formatDomainsData(domainsData?.data);
        setApiData(formattedDomains);
        setIsLoading(false);
      } catch (error) {
        setServerError(error);
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  return { isLoading, apiData, serverError, getOptionFromLevel, combineLevelLabelDomains: getCombineLevelLabelDomains() };
};

const formatDomainsData = (domains: Domains) => {
  let formattedData: { [key: string]: FormattedDomains[] } = {};
  if (domains && domains.length) {
    for (let i = 0; i < domains.length; i++) {
      const item = domains[i];

      const formattedItem = {
        label: item.name,
        value: item.id,
        level: item.level,
        parent_id: item.parent_id,
      };

      if (item.level in formattedData) {
        formattedData[item.level].push(formattedItem);
      } else {
        formattedData[item.level] = [formattedItem];
      }
    }
  }
  return formattedData;
};
